import type { FC } from 'react'

type Props = {
  children: React.ReactNode
}

const EvaluationResultRoot: FC<Props> = ({ children }) => {
  return <div className="flex flex-col gap-6">{children}</div>
}

export default EvaluationResultRoot
